export default "__VITE_ASSET__DTAPzRKl__"